










import { Component, Prop, Vue } from 'vue-property-decorator';
import Booklet from "@/models/booklet";
import HelpContact from "@/models/help-contact";

@Component({
  components: {}
})
export default class HelpContactTile extends Vue {
  @Prop({
    default: null
  })
  public contact!: HelpContact;

  get language() {
    return this.$store.state.lang;
  }

}
